/* eslint-disable */
import http from './http';
import axios, { AxiosError } from 'axios';

export interface Mileage {
  id: string;
  country: string;
  currency: string;
  year: number;
  ratePerMile: number;
  active: boolean;
  createdAt: string;
}

class MileageService {
  static getMileageList(): Promise<Mileage[]> {
    return http
      .get('/mileage/list')
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        }
        throw err;
      });
  }

  static async createMileage(data: any) {
    try {
      const resp = await http.post('/mileage/create', data);
      return resp.data;
    } catch (err: any) {
      throw new Error(err?.response?.data?.message || 'Something went wrong');
    }
  }
}

export default MileageService;
